import * as _ from 'lodash';
import URI from 'urijs';
import { HttpClient } from '@wix/http-client';
import {
  RenderUtils,
  window,
  Wix,
  experimentsWrapper,
  AppSettings,
  Consts,
  watermarkApi,
} from '@wix/photography-client-lib';

const httpClient = new HttpClient();
class Utils extends RenderUtils {
  /* @ngInject */
  constructor() {
    super();

    this._cache = {};
    this._hash2int = {};
    this._refs = {};
    this._params = {};
    this.CONST_ADI_SUPPORT_WIDGET_CODE = '63ff21be-9556-4f52-9ac9-4d441bd3dae4';
    this.CONST_EDITOR_WIDGET_CODE = 'cb6480f3-768b-4737-ab8f-10fe2e4fa2ab';

    this.openManagePhotos = this.openManagePhotos.bind(this);

    try {
      window.document.domain = 'wixapps.net';
    } catch (e) {
      // console.warn('failed to set domain');
    }

    this.isAccessibilityEnabled(); // populate the cache with the sdk response
    this.appSettings = new AppSettings();
  }

  // isStoreGallery() {
  //   return true
  // }

  addItemHashParam(baseUrl, photoId) {
    const curParamsIndex = baseUrl.indexOf('pro-gallery-item=');
    if (curParamsIndex > 0) {
      baseUrl = baseUrl.substr(0, baseUrl.indexOf('pro-gallery-item=') - 1);
    }

    let prefix = '';

    const hashPart = baseUrl.split('#')[1];
    if (hashPart || hashPart == '') {
      const hasQuestionMark = hashPart.split('?')[1];
      if (hasQuestionMark) {
        prefix = '&';
      } else {
        prefix = '?';
      }
    } else {
      prefix = '#?';
    }

    return baseUrl + prefix + 'pro-gallery-item=' + photoId;
  }

  removeItemHashParam(baseUrl) {
    const itemPart = baseUrl.indexOf('pro-gallery-item=');
    // remove anything after the hash
    let newUrl = baseUrl.substr(
      0,
      itemPart > 0 ? itemPart - 1 : baseUrl.length,
    );
    newUrl += newUrl.indexOf('#') > 0 ? '' : '#';
    return newUrl;
  }

  hexToRgba(hex, opacity) {
    hex = hex.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  setStateAndLog(that, caller, state, callback) {
    if (this.isVerbose()) {
      console.log(`State Change Called (${caller})`, state);
      const oldState = _.clone(that.state);
      that['setState'](state, () => {
        const newState = _.clone(that.state);
        const change = this.printableObjectsDiff(oldState, newState, 'state');
        if (_.keys(change).length > 0) {
          console.log(`State Change Completed (${caller})`, change);
        }
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    } else {
      that['setState'](state, () => {
        if (_.isFunction(callback)) {
          callback.bind(that)();
        }
      });
    }
  }

  printableObjectsDiff(obj1, obj2, prefix = '') {
    const toString = (v) => {
      if (v == '') {
        v = "''";
      } else if (_.isUndefined(v)) {
        v = 'undefined';
      }
      return _.toString(v);
    };

    var getInnerDiff = (obj1, obj2, prefix) => {
      const innerDiff = _.reduce(
        obj1,
        (res, v, k) => {
          if (!_.isEqual(v, obj2[k])) {
            if (_.isArray(obj2[k])) {
              if (v.length != obj2[k].length) {
                res[k + '.length'] =
                  '[' + v.length + '] => [' + obj2[k].length + ']';
              }
              res = _.merge(
                res,
                getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k),
              );
            } else if (_.isObject(obj2[k])) {
              res = _.merge(
                res,
                getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k),
              );
            } else {
              res[(prefix ? prefix + '.' : '') + k] =
                toString(v) + ' => ' + toString(obj2[k]);
            }
          }
          return res;
        },
        {},
      );
      return innerDiff;
    };

    return getInnerDiff(obj1, obj2, prefix);
  }

  getViewportScaleRatio() {
    // 320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
    if (this.isMobile() && !this.isMobileViewer() && this.isSite()) {
      return 320 / this.getScreenWidth();
    } else {
      return 1;
    }
  }

  debounceWithContext(context, debouncedFunction, delay = 300) {
    return _.bind(_.debounce(debouncedFunction, delay), context);
  }

  openModalImp(url, width = '100%', height = '100%', onClose = _.noop) {
    return new Promise((resolve, reject) => {
      Wix.Settings.openModal(
        url,
        width,
        height,
        undefined,
        () => {
          onClose();
          resolve();
        },
        true,
        {
          overlay: 'rgba(0,0,0,0)',
          background: 'rgba(0,0,0,0)',
          margin: false,
        },
      );
    });
  }

  openManagePhotos() {
    return this.openModalImp(this.getManageMediaUrl());
  }

  openExpandSettings(params) {
    this.openModalImp(this.getExpandSettingsUrl(params));
  }

  // TODO: function can be deleted
  openTextEditor() {
    this.openModalImp(this.getTextEditorUrl());
  }

  openSettingsWatermarkDisableDialog(callback) {
    Wix.Settings.openModal(
      this.getSettingsWatermarkDisableUrl(),
      612,
      281,
      undefined,
      callback,
      true,
    );
  }

  openSettingsAddonsUrl(params, callback) {
    Wix.Settings.openModal(
      this.getSettingsAddonsUrl(params),
      736,
      281,
      undefined,
      callback,
      true,
    );
  }

  findFontsHrefs() {
    try {
      const isFontHref = (x) => x.toLowerCase().includes('font');
      const styleSheets = top.document.styleSheets;
      return Object.keys(styleSheets)
        .map((s) => styleSheets[s].href)
        .filter((href) => href != null)
        .filter(isFontHref);
    } catch (e) {
      // console.warn('could not find fonts hrefs', e);
      return [];
    }
  }

  getSupportLink(progalleryLinks, storeLinks) {
    let editorArticleId, onBoardingArticleId;
    editorArticleId = this.isStoreGallery()
      ? storeLinks
        ? storeLinks[0]
        : progalleryLinks[0]
      : progalleryLinks[0];
    onBoardingArticleId = this.isStoreGallery()
      ? storeLinks
        ? storeLinks[1]
        : progalleryLinks[1]
      : progalleryLinks[1];
    let articleUrl = '';
    const isOnboarding = this.isOnBoarding() || !editorArticleId;
    if (editorArticleId || onBoardingArticleId) {
      let widgetCode = '';
      let articleId = '';
      const subDomain = 'support';

      const isOnBoardingReallyExists = isOnboarding && onBoardingArticleId;
      const hasOnBoardingOnly = !editorArticleId && onBoardingArticleId;

      if (isOnBoardingReallyExists || hasOnBoardingOnly) {
        widgetCode = this.CONST_ADI_SUPPORT_WIDGET_CODE;
        articleId = onBoardingArticleId;
      } else if (editorArticleId) {
        widgetCode = this.CONST_EDITOR_WIDGET_CODE;
        articleId = editorArticleId;
      }

      if (_.isUndefined(window['locale'])) {
        window['locale'] = 'en';
      }

      const locale = window['locale'];
      const path = `/${locale}/widget/${widgetCode}/article/${articleId}`;
      const url = new URI('https://wix.com/').path(path).subdomain(subDomain);
      articleUrl = url.toString();
    }

    return articleUrl;
  }

  mergeDeep() {
    var _mergeDeep = (dstObj, srcObj) => {
      let mergeId;

      // const clonedDstVal = _.cloneDeep(dstObj);
      const res = _.mergeWith(dstObj, srcObj, (dstVal, srcVal) => {
        if (_.isObject(dstVal) && !_.isFunction(dstVal)) {
          // isObject return true for functions too
          return _mergeDeep(dstVal, srcVal);
        } else {
          return srcVal;
        }
      });

      return res;
    };

    let merged = {};
    for (let i = 0; i < arguments.length; i++) {
      if (arguments[i]) {
        merged = _mergeDeep(merged, arguments[i]);
      }
    }

    return merged;
  }

  getImageUrl(fileName) {
    return (window['staticsUrl'] || '') + fileName;
  }

  markWidgetInSite(widgetId) {
    const instanceId = window['instanceId'];
    this.getLocalStorage()[instanceId + '|has-widget|' + widgetId] = true;
  }

  isWidgetInSite(widgetId) {
    const instanceId = window['instanceId'];
    return !_.isUndefined(
      this.getLocalStorage()[instanceId + '|has-widget|' + widgetId],
    );
  }

  getMobileEnabledClick(action) {
    // todo: bring back this line before pushing to master
    return this.isMobile() ? { onTouchEnd: action } : { onClick: action };
    // return {onClick: action};
  }

  uploadImageFromUrl(imageUrl) {
    const mediaApiBaseUrl = window.siteUrl.includes('editorx')
      ? 'files.editorx.com'
      : 'files.wix.com';
    const uploadMediaUrl = `${
      location.protocol
    }//${mediaApiBaseUrl}/site/media/files/upload/external?media_type=picture&ns=campaign&name=_.jpg&url=${encodeURIComponent(
      imageUrl,
    )}`;
    return this.getUploadMediaRequestNewApi(uploadMediaUrl, 10000);
  }

  getUploadMediaRequestNewApi(uploadMediaUrl, timeout) {
    return httpClient
      .request({
        url: uploadMediaUrl,
        method: 'GET',
        timeout,
        withCredentials: true,
        xsrfCookieName: null,
        headers: {
          Authorization: window.mediaAuth,
        },
      })
      .then(({ data }) => data);
  }

  getYoutubeVideoId(url) {
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      return match[2];
    }
  }

  getVimeoVideoId(url) {
    const regExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    const match = url.match(regExp);
    if (match && match.length > 0) {
      return match[match.length - 1];
    }
  }

  isInExpandSettings() {
    return this.parseGetParam('expandsettingsmode') === '1';
  }

  isStoreDemoImages() {
    // NOTE: the next few lines are commented because otherwise cannot check debugApp=ph_local/ph_debug
    // if (this.isDev()) { //development mode cannot upload images so is is default false
    //   return Promise.resolve(false);
    // }
    if (this.isInExpandSettings()) {
      // expand settings uses default images
      return Promise.resolve(true);
    }

    return this.gallerySettings
      .getAppSettings('isStoreDemoImages')
      .then((isDemo) => {
        if (isDemo === undefined) {
          throw 'not in gallerySettings, fallback to dataPublic';
        }
        return isDemo;
      })
      .catch((e) => {
        return this.data
          .get('isStoreDemoImages')
          .then(() => {
            return false;
          })
          .catch((e) => {
            if (this.isDev()) {
              console.log('error fetching store default images', e);
            }
            return !!(
              e &&
              e.error &&
              e.error.message &&
              e.error.message.indexOf('not found in APP scope') > 0
            );
          });
      });
  }

  getProviderFromGalleryInfo(galleryInfo) {
    if (galleryInfo && galleryInfo.connectedProviders) {
      return Object.keys(galleryInfo.connectedProviders)[0];
    }
    return null;
  }

  dataPublicKey(key) {
    try {
      const compId = Wix.Utils.getOrigCompId() || Wix.Utils.getCompId();
      return key + '-' + compId;
    } catch (e) {
      // console.error('Cannot get compId', e);
      return key + '-no-comp-id';
    }
  }

  data = {
    set: (key, value) => {
      const dataKey = this.dataPublicKey(key);
      return new Promise((resolve, reject) =>
        Wix.Data.Public.set(
          dataKey,
          value,
          { scope: 'APP' },
          (data) => resolve(data.dataKey),
          (err) => reject(err),
        ),
      );
    },
    get: (key) => {
      const dataKey = this.dataPublicKey(key);
      return new Promise((resolve, reject) =>
        Wix.Data.Public.get(
          dataKey,
          { scope: 'APP' },
          (data) => resolve(data.dataKey),
          (err) => reject(err),
        ),
      );
    },
  };

  openMediaDialogAndApplyWatermark(callback) {
    Wix.Dashboard.openMediaDialog(
      Wix.Settings.MediaType.IMAGE_PRO,
      true,
      (result) => {
        const galleryId = window['galleryId'];
        const instance = window['instance'];
        watermarkApi
          .applyWatermarkOnMediaDialogResult(result, galleryId, instance)
          .then((watermarkData) => {
            callback(result);
          });
      },
    );
  }

  colorStringToObject(colorString) {
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    try {
      let returnValue = null;
      if (typeof colorString === 'string') {
        if (colorString.trim().indexOf('rgb') === 0) {
          // rgb(1,2,3) | rgba(4,5,6,0.7)
          const values = colorString.match(/\d+/g);
          if (values && Array.isArray(values) && values.length >= 3) {
            returnValue = {
              r: values[0],
              g: values[1],
              b: values[2],
            };
          }
        } else {
          // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
          const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
          colorString = colorString.replace(shorthandRegex, function (
            m,
            r,
            g,
            b,
          ) {
            return r + r + g + g + b + b;
          });

          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
            colorString,
          );
          returnValue = result
            ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16),
              }
            : null;
        }
      }

      return returnValue;
    } catch (error) {
      console.error('Error converting color string to object', error);
    }
  }

  getExperimentValue(experimentName) {
    return _.get(window, ['petri', `specs.pro-gallery.${experimentName}`]);
  }

  getDateCreatedTicksFromStr(dateCreatedStr) {
    const dateCreatedTicks = null;
    const isDateCreatedValid = isNaN(Date.parse(dateCreatedStr)) === false;
    if (isDateCreatedValid) {
      return Date.parse(dateCreatedStr);
    }
    return -8640000000000000;
  }

  isEditorX() {
    try {
      return window.location.ancestorOrigins[0].includes('editorx');
    } catch (e) {
      return false;
    }
  }

  gallerySettings = (() => {
    const baseUrl =
      window.location.protocol +
      '//progallery.wixapps.net/_api/pro-gallery-editor-webapp/v1/gallery/';
    const getGallerySettingsApi = () =>
      `${baseUrl}${window['galleryId']}?instance=${
        window['instance']
      }&isStore=${this.isStoreGallery()}`;

    return {
      get: (key) => {
        return httpClient
          .get(getGallerySettingsApi(), {
            withCredentials: true,
            xsrfCookieName: null,
          })
          .then(({ data }) => {
            return data.settings
              ? key
                ? data.settings[key]
                : data.settings
              : null;
          });
      },
      set: (key, value) => this.gallerySettings.setMultiple({ [key]: value }),
      setMultiple: (keysValuesObject) => {
        return this.gallerySettings.get().then((data) => {
          data = data || {};
          const settings = Object.assign(data, keysValuesObject);
          return httpClient
            .put(
              getGallerySettingsApi(),
              { settings },
              { withCredentials: true, xsrfCookieName: null },
            )
            .then(() => this.setExternalId());
        });
      },
      getAppSettings: async (key) => {
        if (
          experimentsWrapper.getExperimentBoolean(
            'specs.pro-gallery.appSettings',
          )
        ) {
          try {
            const value = await this.appSettings.get(
              Consts.dataSavedState.SAVED,
              key,
            );
            if (value !== undefined) {
              return Promise.resolve(value);
            }
          } catch (error) {
            console.error(
              'Failed to get ' + key + ' from app settings: ' + error,
            );
          }
        }
        const value = await this.gallerySettings.get(key);
        try {
          if (
            experimentsWrapper.getExperimentBoolean(
              'specs.pro-gallery.appSettings',
            )
          ) {
            this.appSettings.set(key, value);
          }
        } catch (error) {
          console.error('Failed to set ' + key + ' to app settings: ' + error);
        }
        return Promise.resolve(value);
      },
      setAppSettings: async (key, value) => {
        if (
          experimentsWrapper.getExperimentBoolean(
            'specs.pro-gallery.appSettings',
          )
        ) {
          try {
            await this.appSettings.set(key, value);
            // saving to the old server as well, delete when 'specs.pro-gallery.appSettings' wins
            this.set(key, value);
            return Promise.resolve();
          } catch (error) {
            console.error(
              'Failed to set ' + key + ' to app settings: ' + error,
            );
          }
        }
        this.gallerySettings.set(key, value);
      },
      setMultipleAppSettings: async (keysValuesObject) => {
        if (
          experimentsWrapper.getExperimentBoolean(
            'specs.pro-gallery.appSettings',
          )
        ) {
          try {
            await this.appSettings.setMultiple(keysValuesObject);
            // saving to the old server as well, delete when 'specs.pro-gallery.appSettings' wins
            this.setMultiple(keysValuesObject);
            return Promise.resolve();
          } catch (error) {
            console.error(
              'Failed to multiple set ' +
                JSON.stringify(keysValuesObject) +
                ' to app settings: ' +
                error,
            );
          }
        }
        this.gallerySettings.setMultiple(keysValuesObject);
      },
    };
  })();
}

export const utils = new Utils();
